export default {
    signIn: "Sign in",
    signOut: "Sign out",
    enter: "Enter",
    submit: "Submit",
    clickToEnter: "Click to Enter"
}